import {BaseApi} from './base.api';

export const SiteApi = {
  getSite,
  getAllSites
};

function getSite(params){
  return BaseApi.get('/sites', {params: params});
}

function getAllSites(){
  return BaseApi.get('/sites/list');
}
